import React, { useEffect, useRef, useState } from 'react';
import imgNew1 from '../../../assets/news/imgNews1.png';
import imgBienCuaDai from '../../../assets/news/bien-cua-dai-tin1.jpg';
import imgHoiAn from '../../../assets/news/hoi-an-tin2.jpg';
import imgFood from '../../../assets/news/nha-hang-hai-san-tin3.jpg';
import ArrowIcon from '../../../assets/news/arrow-right-circle.svg';
import ArrowHide from '../../../assets/news/arrow-left-circle-hide.png';
import CaHap from '../../../assets/menuList/ca/ca-hap.jpg';
import useDevice from 'utils/use-device';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NewsImg from './NewsImg';
import { useTranslation } from 'react-i18next';
const NewsPage = () => {
  const { t } = useTranslation('header');
  const { isDesktop, isMobile } = useDevice();
  const [currentNumber, setCurrentNumber] = useState(0);
  const [currentNumberReponsvie, setCurrentNumberReponsive] = useState(0);
  const valueImg = 3;
  const valueMax = valueImg - 3;

  const sliderRef: any = useRef(null);
  const handleAfterChange = (currentSlide: number) => {
    setCurrentNumber(currentSlide);
  };

  const handleAfterChangeReponsive = (currentSlide: number) => {
    setCurrentNumberReponsive(currentSlide);
  };
  useEffect(() => {
    setCurrentNumber(0);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    afterChange: handleAfterChange,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          afterChange: handleAfterChangeReponsive,
        },
      },
    ],
  };

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrevious = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div className="relative" id="news">
      <div className=" xl:my-[100px] my-9 xl:px-[100px]">
        <div className="text-center mb-6">
          <h4 className="font-dancing-script text-[#E88532] text-2xl font-bold break-words mb-2">
            {isDesktop && t('news.titleMain')}
            {isMobile && 'Blogs'}
          </h4>
          <h2 className="text-[32px] text-[#225987] font-extrabold break-words mb-[10px]">
            {t('news.subTitle')}
          </h2>
        </div>
        <div className="mb-6 px-4 xl:px-0">
          <Slider ref={sliderRef} {...settings}>
            <div>
              <NewsImg
                srcImg={imgBienCuaDai}
                titleImg={t('news.title1')}
                descript={t('news.describe1')}
              />
            </div>
            <div>
              <NewsImg
                srcImg={imgHoiAn}
                titleImg={t('news.title2')}
                descript={t('news.describe2')}
              />
            </div>

            <div>
              <NewsImg
                srcImg={imgFood}
                titleImg={t('news.title3')}
                descript={t('news.describe3')}
              />
            </div>
          </Slider>
        </div>

        <div className="flex justify-center items-center gap-4">
          <div>
            {currentNumber === 0 && currentNumberReponsvie === 0 ? (
              <img
                src={ArrowHide}
                alt="arrow_right"
                className={'w-6 h-6 cursor-pointer'}
                onClick={handlePrevious}
              />
            ) : (
              <img
                src={ArrowIcon}
                alt="arrow_right"
                className={'w-6 h-6 rotate-180 cursor-pointer'}
                onClick={handlePrevious}
              />
            )}
          </div>
          <div>
            {currentNumber === 3 || currentNumberReponsvie === valueImg - 1 ? (
              <img
                src={ArrowHide}
                alt="arrow_left"
                className="w-6 h-6 cursor-pointer rotate-180"
                onClick={handleNext}
              />
            ) : (
              <img
                src={ArrowIcon}
                alt="arrow_right"
                className={'w-6 h-6 cursor-pointer'}
                onClick={handleNext}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsPage;
